import { Link } from 'react-router-dom';

export const AppFooter = (props: any) => {
    return (
        <footer className="sticky bottom-0 border-t bg-surface-950 border-gray-200 dark:border-[#2A2F31] z-10 pointer-events-auto">
            <div className="mx-auto max-w-screen-xl px-4 py-2 sm:px-6 lg:px-8">
                <div className="flex flex-wrap items-center justify-between gap-4">
                    <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                        <div className="text-2xl font-bold tracking-tighter text-surface-950 dark:text-[#E3E6E8]">
                            icon<span className="text-accent">.</span>
                        </div>
                        <div className="flex gap-x-6">
                            <FooterLink to="/terms-of-service">Terms of Service</FooterLink>
                            <FooterLink to="/privacy-policy">Privacy Policy</FooterLink>
                            <FooterLink to="/faq" >Frequently Asked</FooterLink>
                        </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 sm:justify-end">
                        <p className="text-sm text-surface-500 dark:text-surface-300">
                            Copyright &copy; 2025. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};


const FooterLink = ({ children, to }: { children: React.ReactNode; to: string }) => {
    return (
        <Link
            to={to}
            className="text-sm text-gray-500 dark:text-surface-300 transition 
                    hover:text-gray-900 dark:hover:text-surface-200"
        >
            {children}
        </Link>
    );
};